export enum LtiAlertTypes {
  ALERT_BEST_MATCHED_LIST = 'resourceLinkSingleOption',
  ALERT_NO_MATCHED_LIST = 'resourceLinkNoMatch',
  ALERT_CURRENTLY_LINKED_LIST = 'resourceLinkCreated',
  ALERT_MOST_RECENT_RESOLUTION = 'most_recent_resolution',
}
